export default {
  setSuperUserManuelAccountCollects(state, payload) {
    state.superUserManuelAccountCollects = payload;
  },
};
